import {CommonModule} from '@angular/common';
import {booleanAttribute, ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTabsModule} from '@angular/material/tabs';
import {Router} from '@angular/router';
import {AppRoutingModule} from 'src/app/app-routing.module';
import {SettingButtonComponent} from 'src/app/shared/components/account/setting-button/setting-button.component';
import {UserAvatarComponent} from 'src/app/shared/components/account/user-avatar/user-avatar.component';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    AppRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    UserAvatarComponent,
    SettingButtonComponent
  ]
})
export class TopBarComponent {
  @Input() title?: string;
  @Input() logo?: string;
  @Input() showLogo: boolean = true;
  @Input({transform: booleanAttribute}) withIcon: boolean = true;
  @Input({transform: booleanAttribute}) rounded: boolean = false;
  @Input() toggleMenu?: Function;
  navLinks: any[];
  activeLinkIndex = -1;

  constructor(private router: Router) {
    this.navLinks = [];
  }

  ngOnInit(): void {
    this.router.events.subscribe((res) => {
      this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
    });
  }
}
